<script setup>
  import {computed, inject, onMounted} from "vue";

  import ComponentBreadcrumb from "@components/Breadcrumb/Breadcrumb.vue";
  import ComponentPatientinputClientSidebar from "@components/Sidebars/PatientinputClientSidebar.vue";
  import {useForm, usePage} from "@inertiajs/vue3";
  import PatientinputClientComponentDataSection from "@pages/PatientinputClient/Components/DataSection.vue";
  import {MedSpinner} from "@pharma4u/medicheck-components";
  import {exportPKCS8, exportSPKI, generateKeyPair} from "jose";

  defineOptions({
    name: "PagesPatientinputClientIndex",
  });

  const page = usePage();
  const privacy = inject("$privacy");

  const keysGenerated = computed(() => {
    return page.props.publicKey && page.props.privateKeyEncrypted;
  });

  onMounted(async () => {
    if (!keysGenerated.value) {
      const {privateKey, publicKey} = await generateKeyPair("RSA-OAEP", {
        extractable: true,
      });

      const form = useForm({
        action: "storeKeys",
        public_key: await exportSPKI(publicKey),
        private_key: await privacy.encryptValue(await exportPKCS8(privateKey)),
      });

      form.post(route("patientinput-client.store"));
    }
  });
</script>

<template>
  <div>
    <ComponentBreadcrumb class="mt-2" :links="[{label: 'Fragebögen verwalten'}]" />

    <template v-if="keysGenerated">
      <section class="relative mt-6 flex items-start space-x-6">
        <div class="sticky top-20 z-10">
          <ComponentPatientinputClientSidebar :dynamic-width="true" />
        </div>

        <article
          class="flex flex-1 flex-col items-start space-y-6 2xl:flex-row 2xl:items-start 2xl:space-y-0 2xl:space-x-6"
        >
          <PatientinputClientComponentDataSection :test-id="getTestId()" />
        </article>
      </section>
    </template>

    <template v-else>
      <section class="mt-6">
        <div class="bg-white p-4 text-center shadow-sm">
          <MedSpinner size="2xl" :data-test="getTestId('patientinput-client-index-spinner')" />
        </div>
      </section>
    </template>
  </div>
</template>
